exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".Home__resultWrapper___17Qq- {\n    position: relative;\n    background-color:#ffffff;\n}\n\n.Home__resultWrapper___17Qq-:after {\n    content:\" \";\n    display:table;\n    clear:both;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + "",
	"resultWrapper": "Home__resultWrapper___17Qq-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/Home.icss
// module id = 1243
// module chunks = 0